<template>
	<Loading :loading="loading || wordpressLoading" class="pageContent container">
		<div class="nz-brands row">
			<WordpressContentPage
				pageSlug="nz-brands"
				class="col-12"
				:showLoading="false"
				v-on:loaded="() => {wordpressLoading = false}"
			/>
			<div v-for="brand of availableBrands" :key="brand.product.id" class="col-12 col-md-6 col-lg-4">
				<router-link
                      :to="{name:'brand', params:{brand: brand.product.id, backRoute: $route.fullPath, backName: 'NZ Brands'}}"
                      class="noStyle"
                >
					<img 
						v-if="brand.product.images" 
						:src="imageUrl(brand.product.images[0].sizes, 'small')" 
						:alt="brand.product.title + ' Logo'"
						class="mx-auto d-block"
					>
					<img 
						v-else
						:src="imageUrl([], 'small')" 
						:alt="brand.product.title + ' Logo'"
						class="mx-auto d-block"
					>
					<h3 class="nzBrandsH3">{{brand.product.brand}}</h3>
				</router-link>
				<p v-html="brand.product.description"></p>
			</div>
		</div>
	</Loading>
</template>

<script>

import { fetchNZBrands } from "@/network/brandRequests"
import Loading from "@/components/loading/Loading";
import WordpressContentPage from "@/wordpress/WordpressContentPage";
import { imageUrl } from "@/utils";

export default {
	name: 'NZBrands',
	components: {
		Loading,
		WordpressContentPage,
	},
	data() {
		return {
			brands: null,
			loading: false,
			wordpressLoading: true
		}
	},
	created() {
		this.getData()
	},
	methods: {
		getData() {
			this.loading = true
			fetchNZBrands((res) => {
				this.brands = res
				this.loading = false
			},
			(err) => {
				console.log(err)
				this.loading = false;
			})
		},
		imageUrl
	},
	computed: {
		availableBrands() {
			if(!(this.loading || this.wordpressLoading)){
				let b = []
				for(let brand of this.brands) {
					if (brand != undefined && brand.product.length != 0) {
						b.push(brand)
					}
				}
				return b;
			}
			return null
		}
	},
}
</script>

<style lang="scss" scoped>
.nzBrandsH3 {
	&:hover {
		text-decoration: underline;
	}
}
</style>
